<template>
  <div class="ingredients__body">
    <div class="ingredients__bg"></div>
    <div class="ingredients__title lp-natural__title" v-html="title"></div>
    <div class="ingredients__text lp-natural__text" v-html="text"></div>
    <div class="ingredients__list" v-if="plateMode">
      <ingredients-carousel-item
        v-for="(ingredientData, key) in ingredients"
        class="ingredient"
        :looped-slides="ingredients.length"
        :data="ingredientData"
        @open="openModal(key)"
      >
      </ingredients-carousel-item>
    </div>
    <div class="ingredients-carousel" v-else>
      <swiper
        :loop="true"
        :modules="modules"
        :effect="'coverflow'"
        :centeredSlides="true"
        :slidesPerView="'auto'"
        :coverflowEffect="{
          rotate: 0,
          depth: 0,
          modifier: 1,
          stretch: 46,
          slideShadows: false,
        }"
        :pagination="{ dynamicBullets: true }"
        @swiper="setSwiperRef"
      >
        <swiper-slide
          v-for="(ingredientData, key) in ingredients"
           v-slot="{ isActive }"
        >
          <ingredients-carousel-item
            @open="openModal(key, isActive)"
            class="ingredient"
            :data="ingredientData">
          </ingredients-carousel-item>
        </swiper-slide>
      </swiper>
    </div>
    <ingredients-modal
      v-if="isShowModal"
      :title="title"
      :ingredients="ingredients"
      :initial-slide="initialModalSlide"
      @close="closeModal"
      :key="initialModalSlide"
    >
    </ingredients-modal>
  </div>
</template>

<script setup>
import { ref, computed } from 'vue';
import { EffectCoverflow, Pagination } from 'swiper';


const modules = [EffectCoverflow, Pagination];

const props = defineProps({
  title: {
    type: String,
    default: ''
  },
  text: {
    type: String,
    default: ''
  },
  ingredients: {
    type: Array,
    default: []
  }
});

const isShowModal = ref(false);

const plateMode = computed(() => window.innerWidth > 980);

let swiperRef = ref(null);

const setSwiperRef = (swiper) => {
  swiperRef.value = swiper;
};

const initialModalSlideDesktop = ref(0);

const initialModalSlide = computed(() => {
  return swiperRef.value?.realIndex ?? initialModalSlideDesktop.value;
})

const openModal = (val, isActive) => {
  if (plateMode.value) {
    initialModalSlideDesktop.value = val;
  } else if (!isActive){
    swiperRef.value.slideToLoop(val);
    return;
  }
  isShowModal.value = true;
};

const closeModal = (val) => {
  swiperRef.value && swiperRef.value.slideToLoop(val, 0);
  isShowModal.value = false;
};
</script>
